import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { printServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const printerInstance = axios.create({
  baseURL: printServiceUrl,
  headers,
})

printerInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

printerInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default printerInstance
